import { render, staticRenderFns } from "./PromotionsUpsertForm.vue?vue&type=template&id=7e897d76"
import script from "./PromotionsUpsertForm.vue?vue&type=script&lang=js"
export * from "./PromotionsUpsertForm.vue?vue&type=script&lang=js"
import style0 from "./PromotionsUpsertForm.vue?vue&type=style&index=0&id=7e897d76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports